import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/virtual-hairstyles"
    path="business/products/virtual-hairstyles"
    element={<AsyncPage />}
  />,
];
